// src/services/toolIcons.js
//
// A tool shows either an uploaded logo or one of the curated Lucide glyphs.
// Everything that renders a tool goes through here so the two cases can never
// drift apart.

import { API_BASE_URL } from '../config/api';

export const hasCustomIcon = (tool) => Boolean(tool?.iconImage?.storedName);

// Served without auth by design — see backend/src/utils/iconStorage.js. The
// name is random, and it changes whenever the icon is replaced, which is what
// makes the far-future cache header on it safe.
export const iconUrl = (tool) =>
  hasCustomIcon(tool) ? `${API_BASE_URL}/tools/icons/${tool.iconImage.storedName}` : null;

// A real logo brings its own colour, so it gets the neutral 'logo' tile rather
// than a category tint. Call sites pass this straight to the tile's data-color,
// which is why the swap costs them nothing.
export const tileColor = (tool, category) => (hasCustomIcon(tool) ? 'logo' : category?.color);
